import axios from "axios";
import { URL } from "../config/Api";

export const unauthedApiClient = function(modifyKey) {
  const headers = modifyKey ? { "X-Modify-Key": modifyKey } : null;
  const params = {
    baseURL: URL,
    headers
  };
  return axios.create(params);
};



// WEBPACK FOOTER //
// ./frontend/src/util/UnauthedApiClient.js